"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
/**
 * Comment
 */
class Comment {
    /* CONSTRUCTOR */
    constructor(o = {}) {
        this.id = o.id;
        this.title = o.title || '';
        this.photos = o.photos || '';
        this.commentDate = o.commentDate || (0, moment_timezone_1.default)();
        this.staffId = o.staffId || null;
        this.deleted = o.deleted;
        this.edited = o.edited;
    }
    /* METHODS */
    get commentDateText() {
        return (0, moment_timezone_1.default)(this.commentDate).format('Do MMM');
    }
    isSameAsComment(another) {
        if (another) {
            if (this.id && another.id)
                return this.id === another.id;
            return this.commentDate === another.commentDate && this.staffId === another.staffId;
        }
        return false;
    }
}
exports.Comment = Comment;
exports.default = Comment;
